import constants from "../../../constants/constants";
import {
    ToPersianNumber,
    CommaSeparator
  } from "../../../functions/index";
const Credit = (props) => {
    return (
      <>
      <div className="credit-container">
          <span>{constants.Credit}: {ToPersianNumber(CommaSeparator(props.credit))}<span className={props.credit >= 0 ? "hide" : ""}>-</span> {constants.Currency}</span>
      </div>
      </>
  );
};
export default Credit;